import { render } from "./DetallesPonenete.vue?vue&type=template&id=f2ad77f6"
import script from "./DetallesPonenete.vue?vue&type=script&lang=js"
export * from "./DetallesPonenete.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__